export default __webpack_public_path__ + "static/media/952.2047f004.gif";